import amountToFixed from "@/helper/amountToFixed";
import {
  CartItemContainer,
  StyledInput,
  CartItemTitle,
  CartItemPrice,
  DeleteIcon,
  ContainerFlex,
  CartItemDiscountContainer,
  CartItemContainerBody,
} from "./cart.styled";
import { parseAmount } from "@/helper/parseAmount";
import { useMainPageContext } from "@/contexts/MainPageContext";
import { getItemPromotionAmount } from "@fripick/cart-utils";
import { getPromotionName } from "@/helper/promotions";

export default function CartItem({ product }) {
  const {
    editProductQuantity,
    handleZeroQuantity,
    deleteComboCart,
    deleteProductCart,
  } = useMainPageContext();
  const hasPromotion = product.promotion;
  const productPrice = parseAmount(product.price) * Number(product.quantity);
  const discountedPrice = hasPromotion
    ? productPrice -
      getItemPromotionAmount(
        parseAmount(product.price),
        Number(product.quantity),
        product.promotion,
      )
    : 0;
  const productPriceFormatted = `RD$ ${amountToFixed(productPrice, 2)}`;
  return (
    <CartItemContainer key={product.combo ? product.key : product.id}>
      <CartItemContainerBody>
        <ContainerFlex>
          <StyledInput
            sx={{ input: { color: "#696969" } }}
            disableUnderline
            type="number"
            value={product.quantity}
            onBlur={() => handleZeroQuantity()}
            onChange={(e) => {
              editProductQuantity(
                product.combo ? product.key : product.id,
                e.target.value,
                product.combo,
              );
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CartItemTitle style={{ wordBreak: "break-word" }}>
              {product.name}
            </CartItemTitle>
          </div>
        </ContainerFlex>
        <ContainerFlex>
          {!hasPromotion && (
            <CartItemPrice>{productPriceFormatted}</CartItemPrice>
          )}
          <DeleteIcon
            onClick={() => {
              product.selectedProductIndexes
                ? deleteComboCart(product)
                : deleteProductCart(product.id);
            }}
          />
        </ContainerFlex>
      </CartItemContainerBody>
      {hasPromotion && (
        <>
          <CartItemDiscountContainer>
            <span className="promo-name">
              {getPromotionName(product.promotion)}{" "}
            </span>
            <span className="original-amount">{productPriceFormatted}</span>
            <span className="total-amount">{`RD$ ${amountToFixed(discountedPrice, 2)}`}</span>
          </CartItemDiscountContainer>
        </>
      )}
    </CartItemContainer>
  );
}
